import axios from "../index.js"

var module = {
    // 获取模块下的全部列表
	getLinkListByModule:function(data,success,failure){
		return axios.get(`${axios.apiRoot}/dashboard/getLinkListByModule`,data,success,failure);
	},
}

export default module


// WEBPACK FOOTER //
// ./src/api/url/module.js